export const on = (event: string, callback: (...args: any[]) => void) => {
  document.addEventListener(event, (e: any) => {
    callback(e.detail?.data, {
      resolve: e.detail?.resolve,
      reject: e.detail?.reject,
    });
  });
};

export const dispatch = (event: string, data?: any) => {
  document.dispatchEvent(new CustomEvent(event, { detail: { data } }));
};

export const asyncDispatch = async <T = any>(event: string, data?: any) => {
  return new Promise<T>((resolve, reject) => {
    document.dispatchEvent(new CustomEvent(event, { detail: { data, resolve, reject } }));
  });
};

export const remove = (event: string, callback: (...args: any[]) => void) => {
  document.removeEventListener(event, callback);
};
